import { MockupFrame } from "./MarketingChannelMockups";
import { RevealItem, RevealSequence } from "./RevealSequence";
import { getBarWidthPercent, getChartMaxValue } from "@/utils/chartMockup";

export type StudioChartRow = {
  label: string;
  value: number;
};

export type StudioChartMockupProps = {
  rows: StudioChartRow[];
  footnote?: string;
  showTrendArrow?: boolean;
};

export function StudioChartMockup({
  rows,
  footnote,
  showTrendArrow = true,
}: Readonly<StudioChartMockupProps>) {
  const values = rows.map((row) => row.value);
  const max = getChartMaxValue(values);

  return (
    <MockupFrame rounded="all">
      <RevealSequence className="flex-1 p-3">
        <div className="space-y-2.5">
          {rows.map((row, index) => (
            <RevealItem
              key={`${row.label}-${index}`}
              order={index}
              className="flex items-center gap-2"
            >
              <span className="w-[4.5rem] shrink-0 truncate font-monument text-[0.625rem] text-black/55">
                {row.label}
              </span>
              <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-black/10">
                <span
                  className="block h-full rounded-full bg-black/70"
                  style={{ width: `${getBarWidthPercent(row.value, max)}%` }}
                />
              </span>
              <span className="w-8 shrink-0 text-right font-monument text-[0.625rem] text-black/55">
                {row.value}
              </span>
            </RevealItem>
          ))}
        </div>
        {footnote ? (
          <RevealItem order={rows.length}>
            <p className="mt-4 font-monument text-[0.625rem] font-medium leading-snug text-emerald-800">
              {showTrendArrow ? (
                <span aria-hidden>↑ </span>
              ) : null}
              {footnote}
            </p>
          </RevealItem>
        ) : null}
      </RevealSequence>
    </MockupFrame>
  );
}
